/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_6_AInputs */

const en_mk_pricing_faq_6_a = /** @type {(inputs: Mk_Pricing_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing is deleted. Anything above the new plan’s limits becomes read-only until you tidy it up yourself or move back up.`)
};

const id_mk_pricing_faq_6_a = /** @type {(inputs: Mk_Pricing_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada data yang dihapus. Yang melebihi batas paket baru menjadi hanya-baca sampai Anda merapikannya sendiri atau naik paket lagi.`)
};

/**
* | output |
* | --- |
* | "Nothing is deleted. Anything above the new plan’s limits becomes read-only until you tidy it up yourself or move back up." |
*
* @param {Mk_Pricing_Faq_6_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_6_a = /** @type {((inputs?: Mk_Pricing_Faq_6_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_6_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_6_a(inputs)
	return en_mk_pricing_faq_6_a(inputs)
});